import React from 'react';
import { motion } from 'framer-motion';

const GlassCard = ({
  children,
  className = '',
  hover = true,
  delay = 0,
  lang = 'en', // Added lang prop
}) => {
  const isAr = lang === 'ar';

  return (
    <motion.div
      // Standard fade-up animation remains consistent for both languages
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{
        duration: 0.5,
        delay: delay,
      }}
      // Subtle scale effect that feels "Premium"
      whileHover={
        hover
          ? {
              y: -8,
              scale: 1.02,
              transition: { duration: 0.2 },
            }
          : {}
      }
      // We force the text alignment based on the language for this specific card
      className={`glass-card ${isAr ? 'text-right' : 'text-left'} ${className}`}
      style={{
        // Adding a slight backdrop-filter fallback for older browsers
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      {children}
    </motion.div>
  );
};

export default GlassCard;
